import { createIdbAuthStorage } from "@fieldbook/common/authStorage"
import type { AuthStorageService } from "../types"

export const authStorage: AuthStorageService = createIdbAuthStorage()
